'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const MarketAllocationError = () => {
  return <ErrorDataUnavailable minHeight="320px" />
}

export default memo(MarketAllocationError)
